import React, { useState, useEffect, useContext } from "react";
import { Spinner } from "../../StyledComponent";
import { getVideos } from "../../../services/meuImovel";
import { ContextNotificacoes } from "../../../services/notificacoes";
import { ContextoListaApartamentos } from "../../ApartamentList/contextoImoveis";
import Fade from "@material-ui/core/Fade";
import { Button } from "../buttonStyled";
import NotFoundError from "../NotFoundError";
import "./styles.scss";
const Videos = ({ idEmpreendimentoImovelSelecionado, videoId }) => {
  const [videos, setVideos] = useState([]);

  const [loadingVideos, setLoadingVideos] = useState(true);

  const [watchAllVideos, setWatchAllVideos] = useState(true);

  const [errorMsg, setErrorMsg] = useState(false);

  const [loadAllVideosButton, setLoadAllVideosButton] = useState(true);

  const { handleNotificationError } = useContext(ContextNotificacoes);

  const { tema } = useContext(ContextoListaApartamentos);

  useEffect(() => {
    resetStates();
    if (idEmpreendimentoImovelSelecionado) loadVideos();
  }, [idEmpreendimentoImovelSelecionado]);

  function resetStates() {
    setLoadingVideos(true);
    setVideos([]);

    setErrorMsg(false);
  }

  async function loadVideos() {
    let resultGetVideos = await getVideos(idEmpreendimentoImovelSelecionado);

    if (resultGetVideos == false) {
      setErrorMsg(true);
      setLoadingVideos(false);
    } else {
      if (videoId && !verificaSeVideoExiste(resultGetVideos)) {
        handleNotificationError();
        return;
      }

      setVideos(
        resultGetVideos.sort(
          (a, b) =>
            new Date(b.LastModifiedDate).getTime() -
            new Date(a.LastModifiedDate).getTime()
        )
      );
      setLoadAllVideosButton(true);
      setLoadingVideos(false);
      setErrorMsg(false);
    }
  }

  function verificaSeVideoExiste(resultGetVideos) {
    let existe = resultGetVideos?.filter((video) => video.Id === videoId);
    if (existe.length > 0) return true;
  }

  if (loadingVideos) return <Spinner />;

  return (
    <>
      <div>
        {videos.length > 0 && (
          <Fade in>
            <div className="grid-container">
              {videos
                .filter((q, i) => (watchAllVideos ? i < 4 : true))
                .map((video) => (
                  <>
                    <Fade in>
                      <div className="grid-item" key={video.Id}>
                        <div>
                          <iframe
                            width="100%"
                            height="100%"
                            src={video.UrlVideo}
                            frameBorder="0"
                            allowFullScreen
                            title="Embedded youtube"
                          />
                          <span style={{ fontSize: "12px", color: "#4d4d4d" }}>
                            {video.Nome}
                          </span>
                        </div>
                      </div>
                    </Fade>
                  </>
                ))}
            </div>
          </Fade>
        )}
        {videos.length > 4 && !errorMsg && loadAllVideosButton && (
          <Button
            bg={tema.primaryColor}
            onClick={() => {
              setWatchAllVideos(false);
              setLoadAllVideosButton(false);
            }}
          >
            ver todos vídeos
          </Button>
        )}

        {errorMsg && <NotFoundError text={"Nenhum vídeo encontrado."} />}
      </div>
    </>
  );
};

export default Videos;
